import { usePostMutation } from "@/api/swr/useMutation";
import { companyCreateSchema } from "@/schema/console/companies/CompanyCreate";
import { z } from "zod";

const companyCreateResSchema = z.object({
  id: z.number(),
});

type Config = Parameters<
  typeof usePostMutation<
    typeof companyCreateSchema,
    typeof companyCreateResSchema
  >
>[3];

export function useCreateCompany(config: Config) {
  return usePostMutation(
    companyCreateSchema,
    companyCreateResSchema,
    "/console/companies",
    config,
  );
}
